<template>
  <v-container>
    <div class="title-icon top">
      <h1 v-if="$route.params.departmentId && $route.params.departmentId > 0">
        {{ $t("company.edit-department") }}
      </h1>
      <h1 v-else>{{ $t("company.new-department") }}</h1>
      <v-btn
        icon
        :href="links.main.departments"
        target="_blank"
      >
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div>

    <v-form ref="valid" v-model="valid" lazy-validation>
      <v-text-field
        value=""
        v-model="departmentName"
        class="mt-1"
        outlined
        :rules="[rules.required]"
        :label="$t('labels.name') + '*'"
      ></v-text-field>
      <v-textarea
        :label="$t('labels.description')"
        outlined
        name="input-7-4"
        rows="10"
        v-model="description"
      ></v-textarea>
      <v-autocomplete
        v-model="adminIds"
        :items="admins"
        outlined
        multiple
        item-text="text"
        item-value="personId"
        :label="$t('company.department-admin')"
        append-icon="$sl-arrow-down"
        prepend-inner-icon="$sl-departments-admin "
        chips                        
      >
        <template v-slot:selection="{ attrs, item, selected }">
          <v-chip
            close-icon="$sl-close"
            v-bind="attrs"
            :input-value="selected"
            close
            @click:close="removeAdmin(item)"
          >
            {{ item.text }}</v-chip
          >          
        </template>        
      </v-autocomplete>
      <!-- <v-select
        class="mt-5"
        outlined
        v-model="adminIds"
        :items="admins"
        multiple
        item-text="text"
        item-value="personId"
        :label="$t('company.department-admin')"
        append-icon="$sl-arrow-down"
        prepend-inner-icon="$sl-departments-admin"
        chips
      >
        <template v-slot:selection="{ attrs, item, selected }">
          <v-chip
            close-icon="$sl-close"
            v-bind="attrs"
            :input-value="selected"
            close
            @click:close="removeAdmin(item)"
          >
            {{ item.text }}</v-chip
          >
        </template></v-select
      > -->
<!-- <v-autocomplete
        v-model="adminIds"
        :items="admins"
        outlined
        multiple
        item-text="text"
        item-value="personId"
        :label="$t('company.department-admin')"
        append-icon="$sl-arrow-down"
        prepend-inner-icon="$sl-distance-admin"
        chips                        
      > -->
      <v-autocomplete
        outlined
        v-model="distanceAdminIds"
        :items="distanceAdmins"
        multiple
        item-text="text"
        item-value="personId"
        :label="$t('company.department-distance-admin')"
        append-icon="$sl-arrow-down"
        prepend-inner-icon="$sl-distance-admin"
        chips
      >
        <template v-slot:selection="{ attrs, item, selected }">
          <v-chip
            close-icon="$sl-close"
            v-bind="attrs"
            :input-value="selected"
            close
            @click:close="removeDistance(item)"
            >{{ item.text }}</v-chip
          >
        </template></v-autocomplete>
      <v-autocomplete
        outlined
        v-model="yuaIds"
        :items="yua"
        multiple
        item-text="text"
        item-value="personId"
        :label="$t('roles.yua')"
        append-icon="$sl-arrow-down"
        prepend-inner-icon="$sl-yua"
        chips
      >
        <template v-slot:selection="{ attrs, item, selected }">
          <v-chip
            close-icon="$sl-close"
            v-bind="attrs"
            :input-value="selected"
            close
            @click:close="removeYUA(item)"
            >{{ item.text }}</v-chip
          >
        </template></v-autocomplete>
      <v-autocomplete
        outlined
        v-model="instructorIds"
        :items="instructors"
        multiple
        item-text="text"
        item-value="personId"
        :label="$t('labels.instructor')"
        append-icon="$sl-arrow-down"
        prepend-inner-icon="$sl-instructor"
        chips
      >
        <template v-slot:selection="{ attrs, item, selected }">
          <v-chip
            close-icon="$sl-close"
            v-bind="attrs"
            :input-value="selected"
            close
            @click:close="removeInstructor(item)"
            >{{ item.text }}</v-chip
          >
        </template></v-autocomplete>
    </v-form>
    <ActionButton
      v-if="$route.params.departmentId && $route.params.departmentId > 0"
      @click="update"
      actionIcon="$sl-departments"
      :isDisabled="isImitatingUser()"
      >{{ $t("company.btn-edit-section") }}</ActionButton
    >
    <ActionButton v-else @click="save" actionIcon="$sl-departments" :isDisabled="isImitatingUser()">{{
      $t("company.add-section")
    }}</ActionButton>
  </v-container>
</template>

<script>
import API from "@/services/api.js";
import { RulesMixin } from "@/components/mixins";
import ActionButton from "@/components/Common/ActionButton";
import find from "lodash/find";
import sortBy from "lodash/sortBy";
import findIndex from "lodash/findIndex";
import { mapActions, mapGetters } from "vuex";

// @group Company
// CompanyExemption component
export default {
  name: "CompanyExemption",

  mixins: [RulesMixin],

  components: {
    ActionButton,
  },

  data: () => ({
    links: require('../../lib/external-links.json'),
    valid: false,

    departmentName: "",
    description: "",
    selectedIds: [],
    admins: [],
    adminIds: [],
    distanceAdmins: [],
    selectedDep: {},
    distanceAdminIds: [],
    yua: [],
    yuaIds: [],
    instructors: [],
    instructorIds: [],
  }),

  mounted() {
    this.$scrollToTop();
  },

  created() {
    this.init();
  },

  computed: {
    ...mapGetters("basic", ["basicProfessions"]),
    ...mapGetters('currentuser', ['isImitatingUser']),
  },

  methods: {
    /**
     * @vuese
     * Used to call method  getEmployees and getDepartment
     * @arg called with no argument
     */
    init() {
      this.getEmployees();
      this.getDepartment();
    },
    /**
     * @vuese
     * Used to get the selected department
     * @arg called with no argument
     */
    getDepartment() {
      if (
        !(
          this.$route &&
          this.$route.params &&
          this.$route.params.id &&
          this.$route.params.departmentId
        )
      )
        return;

      let seletectedDepartment = {};

      API.getDepartment(this.$route.params.id, this.$route.params.departmentId)
        .then((response) => {
          seletectedDepartment = response.data;
          this.selectedDep=response.data;
          if (seletectedDepartment.name) {
            this.departmentName = seletectedDepartment.name;
          }
          if (seletectedDepartment.description) {
            this.description = seletectedDepartment.description;
          }
          if (seletectedDepartment.administratorIds) {
            this.adminIds = seletectedDepartment.administratorIds;
          }
          if (seletectedDepartment.distanceEducationAdministrators) {
            this.distanceAdminIds =
              seletectedDepartment.distanceEducationAdministratorIds;
          }
          if (seletectedDepartment.instructorIds) {
            this.instructorIds = seletectedDepartment.instructorIds;
          }
          if (seletectedDepartment.companyEducationResponsibleIds) {
            this.yuaIds = seletectedDepartment.companyEducationResponsibleIds;
          }
        })
        .catch((error) => {
          console.log("There was an error:", error);
        });
    },

    /**
     * @vuese
     * Used to remove the selected value
     */
    removeAdmin(item) {
      this.adminIds.splice(this.adminIds.indexOf(item.personId), 1);
    },
    removeDistance(item) {
      this.distanceAdminIds.splice(this.distanceAdminIds.indexOf(item.personId), 1);
    },
    removeYUA(item) {
      this.yuaIds.splice(this.yuaIds.indexOf(item.personId), 1);
    },
    removeInstructor(item) {
      this.instructorIds.splice(this.instructorIds.indexOf(item.personId), 1);
    },

    /**
     * @vuese
     * Used to fetch employees
     * @arg The argument is an integer value representing company id
     */
    getEmployees() {
      API.listEmployments(this.$route.params.id)
        .then((response) => {
          let textName = "";
          let arrEmp=sortBy(response.data, 'employed.lastName' )          
          arrEmp.forEach((o) => {
            textName = "";
            if (o.employed.firstName && o.employed.lastName) {
              textName = o.employed.firstName + " " + o.employed.lastName;
            } else if (o.employed.email) {
              textName = o.employed.email;
            }
            this.admins.push({
              employee_id: o.id,
              personId: o.id,
              text: textName,
            });

            this.distanceAdmins = this.admins;

            this.yua = this.admins;

            this.instructors = this.admins;
          });
        })
        .catch((error) => {
          console.log("catch Error");
        });
    },

    /**    
    /**
     * @vuese
     * Used to save the new department
     * @arg The argument is an array of files
     */
    save() {
      if (!this.$refs.valid.validate()) {
        this.$events.fire("showError", this.$t("errors.form-failure"));
        return;
      }

//let params=this.seletectedDepartment
      let params = {
        name: this.departmentName,
        description: this.description,
        instructorIds: this.instructorIds,
        companyEducationResponsibleIds: this.yuaIds,
        distanceEducationAdministratorIds: this.distanceAdminIds,
        administratorIds: this.adminIds,
      };

      API.createDepartment(this.$route.params.id, { data: params })
        .then((response) => {
          if (response && response.data) {
            this.$nextTick(() => {
              this.$router.push({
                name: "CompanyDepartments",
                params: { id: this.$route.params.id },
              });
            });
          }
        })
        .catch((error) => {
          console.log("catch Error", error);

          this.$events.fire("showError", this.$t("error.save-error"));
        });
    },
    update() {
      if (!this.$refs.valid.validate()) {
        this.$events.fire("showError", this.$t("errors.form-failure"));
        return;
      }
// //       let params = this.selectedDep
// // {
// //         name: this.departmentName,
// //         description: this.description,
// //         instructorIds: this.instructorIds,
// //         companyEducationResponsibleIds: this.yuaIds,
// //         distanceEducationAdministratorIds: this.distanceAdminIds,
// //         administratorIds: this.adminIds,
//   //       };
    this.selectedDep.name=this.departmentName
    this.selectedDep.description=this.description
    this.selectedDep.instructorIds=this.instructorIds
    this.selectedDep.companyEducationResponsibleIds=this.yuaIds
    this.selectedDep.distanceEducationAdministratorIds=this.distanceAdminIds
    this.selectedDep.administratorIds=this.adminIds
//console.log("selectedDep", this.selectedDep)
      API.updateDepartment(this.$route.params.id, this.$route.params.departmentId, {
        data: this.selectedDep,
      })
        .then((response) => {
          if (response && response.data) {
            this.$events.fire("showInfo", this.$t("success.saved"));
            this.$nextTick(() => {
              this.$router.push({
                name: "CompanyDepartments",
                params: { id: this.$route.params.id },
              });
            });
          }
        })
        .catch((error) => {
          console.log("catch Error", error);
          this.$events.fire("showError", this.$t("error.save-error"));
        });
    },
  },
};
</script>
